// Path: src\Components\Profile\EditProfile.jsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import BaseHome from "../Home/BaseHome";
import { TextField, InputAdornment } from "@mui/material";
import FlagIcon from "../../assets/images/indianflag.png"; // Example icon, you can replace it with an Indian flag icon if needed
import Userchar3 from "../../assets/images/userchar3.png";
import Userchar2 from "../../assets/images/userchar2.png";
import Userchar1 from "../../assets/images/userchar.png";
import Lock from "../../assets/images/lock.png";
import Premiumuser from "../../assets/images/premiumicons.png";
import tickmark from "../../assets/images/tickmark.png";
import {
  getEditProfile,
  getAvatarList,
  updateEditProfile,
} from "../../api/profile.api";
import { url } from "../../config/url";
import moment from "moment/moment";
import TextInput from "../CommonFields/TextInput";
import DateTimePopup from "../Popup/DateTimePopup";
import {
  generateNumberArray,
  generateMonths,
  generateArrayOfYears,
} from "../Popup/Utils";
import { toastError, toastSuccess } from "../../Utilities/toast";
import { useTranslation } from "react-i18next";
import { routesFrontend } from "../RouterFiles/routes";
import { useNavigate } from "react-router";
const EditProfile = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState("");
  const [avatarList, setAvatarList] = useState([]);
  const [isDateTimePopup, setDateTimePopup] = useState(false);
  const [userProfilePhone, setUserProfilePhone] = useState("");
  const [userProfileEmail, setUserProfileEmail] = useState("");
  const [userProfileGamerjiName, setUserProfileGamerjiName] = useState("");
  const [userProfileAvtar, setUserProfileAvtar] = useState("");
  const [userProfileDateOfBirth, setUserProfileDateOfBirth] = useState("");
  const [emailError, setEmailError] = useState("");
  const [dateOfBirthError, setDateOfBirthError] = useState("");
  const [avatarError, setAvatarError] = useState("");
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [lastVerifiedEmail, setLastVerifiedEmail] = useState("");
  const [isPremiumUser, setIsPremiumUser] = useState(false);
  const [isSaveBtnDisable, setIsSaveBtnDisable] = useState(false);

  useEffect(() => {
    fetchUserProfile();
    fetchAvatarList();
    var isPremium = localStorage?.getItem('premiumUser') || false
    setIsPremiumUser(isPremium == true || isPremium == "true" ? true : false)
  }, []);

  const fetchUserProfile = async () => {
    try {
      const res = await getEditProfile();
      if (res?.success && res?.data) {
        setUserProfile(res?.data);
        setUserProfilePhone(res?.data?.phone || "");
        setUserProfileEmail(res?.data?.email || "");
        setUserProfileGamerjiName(res?.data?.gamerjiName || "");
        setUserProfileAvtar(res?.data?.avatar || "");
        setUserProfileDateOfBirth(res?.data?.dateOfBirth || "");
        setIsEmailVerified(res?.data?.isEmailVerified || false);
      } else {
        setUserProfile("");
        setUserProfilePhone("");
        setUserProfileEmail("");
        setUserProfileGamerjiName("");
        setUserProfileAvtar("");
        setUserProfileDateOfBirth("");
        setIsEmailVerified(false);
      }
    } catch (error) {
      setUserProfile("");
      setUserProfilePhone("");
      setUserProfileEmail("");
      setUserProfileGamerjiName("");
      setUserProfileAvtar("");
      setUserProfileDateOfBirth("");
      setIsEmailVerified(false);
    }
  };

  const fetchAvatarList = async () => {
    try {
      let data = {
        pagination: {
          pageNo: 1,
          recordPerPage: 100,
          sortBy: "createdAt",
          sortDirection: "asc",
        },
        search: {
          allAvatar: true,
        },
      };
      const res = await getAvatarList(data);
      if (res?.success && res?.data) {
        setAvatarList(res?.data);
      } else {
        setAvatarList("");
      }
    } catch (error) {
      setAvatarList("");
    }
  };

  const handleOpenPopup = () => {
    setDateTimePopup(true);
  };

  const toggleDateTimePopup = () => {
    setDateTimePopup((prevState) => !prevState);
  };
  const handleDateSave = (formattedDate) => {
    const [day, month, year] = formattedDate.split("/");
    const paddedDay = day.padStart(2, "0"); // Add leading zero if needed
    const paddedMonth = month.padStart(2, "0"); // Add leading zero if needed
    const formatted = `${paddedDay}-${paddedMonth}-${year}`; // Convert to "dd-mm-yyyy"
    setDateTimePopup(false); // Close the popup
    setUserProfileDateOfBirth(`${year}-${paddedMonth}-${paddedDay}`); // Update state with the selected date
    setDateOfBirthError("");
  };

  const handleAvatarChange = (id) => {
    setAvatarError("");
    setUserProfileAvtar(id);
  };

  let premiumUser = localStorage?.getItem('premiumUser') || false;

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .trim()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleSubmit = async (e) => {
    setEmailError("");
    setDateOfBirthError("");
    setAvatarError("");

    let validateEmailRes = validateEmail(userProfileEmail);
    if (!userProfileDateOfBirth) {
      setDateOfBirthError("Please enter a valid date");
      return;
    }
    const selectedYear = new Date(userProfileDateOfBirth).getFullYear();
    const nowYear = new Date().getFullYear();
    const minimumYear = nowYear - 18;
    
    console.log(minimumYear);
    console.log(nowYear);
    
    if (selectedYear <= 1970) {
      setDateOfBirthError(t("Please select a year 1970 or after."));
      return;
    } else if (selectedYear === " " || selectedYear === null) {
      setDateOfBirthError(t("Please select date of birth."));
      return;
    } else if (selectedYear > minimumYear) {
      setDateOfBirthError(t("You must be at least 18 years old."));
      return;
    }
    else if (!validateEmailRes) {
      // toastError(t("please enter valid email id"));
      setEmailError(t("please enter valid email id"));
      return;
    } else if (!userProfileAvtar) {
      toastError(t("please select avatar"));
      return;
    } else {
      setIsSaveBtnDisable(true);
      try {
        const res = await updateEditProfile({
          email: userProfileEmail,
          dateOfBirth: new Date(userProfileDateOfBirth),
          avatar: userProfileAvtar,
        });
        if (res?.success) {
          toastSuccess("Profile updated successfully");
          fetchUserProfile();
          setTimeout(() => {
            navigate(routesFrontend.profile);
          }, 6000);
        } else {
          setIsSaveBtnDisable(false);
          toastError(res?.data?.errors?.[0]?.msg);
        }
      } catch (error) {
        setIsSaveBtnDisable(false);
        toastError(error?.response?.data?.errors?.[0]?.msg);
      }
    }
  };

  return (
    <BaseHome title={"edit profile"}>
      <div className="e-sports-edit-userprofile-main">
        <div className="e-sports-edit-userprofile-inner-wrap">
          {/* Country Code and Mobile Number */}

          <div className="mobile-emailfield">
            <div className="e-sports-edit-userprofile-field">
              <TextField
                label="country code"
                defaultValue="+91"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={FlagIcon} alt="flag" />
                    </InputAdornment>
                  ),
                  readOnly: true, // This will make the field read-only
                }}
                variant="outlined"
                className="e-sports-edit-userprofile-input"
                value={userProfile?.phoneCode}
              />
            </div>

            <div className="e-sports-edit-userprofile-field">
              <TextField
                label="mobile number"
                variant="outlined"
                className="e-sports-edit-userprofile-input"
                InputProps={{
                  readOnly: true, // This will make the field read-only
                }}
                value={userProfilePhone}
              />
            </div>
          </div>

          {/* Date of Birth */}
          <div className="col-12 e-sports-edit-userprofile-field">
          <div className="datepicker-input--wrap">
  <TextField
    className="mt-2"
    label="date of birth"
    placeholder="dd/mm/yyyy"
    value={
      userProfileDateOfBirth
        ? moment(userProfileDateOfBirth).format("DD/MM/YYYY")
        : ""
    }
    onMouseDown={(e) => {
      e.preventDefault();
    }}
    inputMode="text"
    autoComplete="off"
    onChange={(e) => e.preventDefault()} // Prevent manual changes
    readOnly // Make the input read-only
    onClick={handleOpenPopup} // Open popup on click
    helperText={dateOfBirthError}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <svg
                onClick={toggleDateTimePopup}
                style={{ cursor: "pointer" }}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2737_8465)">
                  <path
                    d="M17.66 1.56H16.72V0H15.16V1.56H4.84V0H3.28V1.56H2.34C1.05 1.56 0 2.61 0 3.91V17.66C0 18.95 1.05 20 2.34 20H17.65C18.94 20 19.99 18.95 19.99 17.66V3.91C19.99 2.62 18.94 1.57 17.65 1.57L17.66 1.56ZM18.44 17.66C18.44 18.09 18.09 18.44 17.66 18.44H2.34C1.91 18.44 1.56 18.09 1.56 17.66V7.34H18.44V17.65V17.66ZM18.44 5.78H1.56V3.9C1.56 3.47 1.91 3.12 2.34 3.12H3.28V4.68H4.84V3.12H15.15V4.68H16.71V3.12H17.65C18.08 3.12 18.43 3.47 18.43 3.9V5.78H18.44Z"
                    fill="white"
                  />
                  <path d="M4.53 8.98H2.97V10.54H4.53V8.98Z" fill="white" />
                  <path d="M7.65 8.98H6.09V10.54H7.65V8.98Z" fill="white" />
                  <path d="M10.78 8.98H9.22V10.54H10.78V8.98Z" fill="white" />
                  <path d="M13.9 8.98H12.34V10.54H13.9V8.98Z" fill="white" />
                  <path d="M17.03 8.98H15.47V10.54H17.03V8.98Z" fill="white" />
                  <path d="M4.53 12.11H2.97V13.67H4.53V12.11Z" fill="white" />
                  <path d="M7.65 12.11H6.09V13.67H7.65V12.11Z" fill="white" />
                  <path d="M10.78 12.11H9.22V13.67H10.78V12.11Z" fill="white" />
                  <path d="M13.9 12.11H12.34V13.67H13.9V12.11Z" fill="white" />
                  <path d="M4.53 15.23H2.97V16.79H4.53V15.23Z" fill="white" />
                  <path d="M7.65 15.23H6.09V16.79H7.65V15.23Z" fill="white" />
                  <path d="M10.78 15.23H9.22V16.79H10.78V15.23Z" fill="white" />
                  <path d="M13.9 15.23H12.34V16.79H13.9V15.23Z" fill="white" />
                  <path
                    d="M17.03 12.11H15.47V13.67H17.03V12.11Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2737_8465">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
        </InputAdornment>
      ),
      readOnly: true,
      tabIndex: -1,
    }}
    sx={{
      '& .MuiInputBase-input': {
        cursor: 'pointer', // Optional: style the input cursor
      },
    }}
  />
  {dateOfBirthError && (
    <div className="error-message" style={{ fontSize: "12px" }}>
      {dateOfBirthError}
    </div>
  )}
</div>
        
          </div>

          <></>
          {isDateTimePopup && (
            <DateTimePopup
              isOpen={isDateTimePopup}
              title={"Select Date"}
              onClose={() => setDateTimePopup(false)}
              onSave={handleDateSave} // Pass handleSaveDate to DateTimePopup
              dayOptions={generateNumberArray(1, 8, 2024)}
              monthOptions={generateMonths()}
              yearOptions={generateArrayOfYears()}
            />
          )}

          {/* Email */}
          <div className="col-12 e-sports-edit-userprofile-field">
            <TextField
              label="email"
              placeholder="please enter your email id"
              variant="outlined"
              className="e-sports-edit-userprofile-input mt-2"
              value={userProfileEmail}
              helperText={emailError}
              onChange={(e) => {
                setEmailError("");
                setUserProfileEmail(e.target.value);
                setIsEmailVerified(false); // Remove the icon on change
              }}
              InputProps={{
                endAdornment: isEmailVerified ? (
                  <InputAdornment position="end">
                    <img
                      src={tickmark}
                      alt="Verified"
                      className="verified-icon"
                    />
                  </InputAdornment>
                ) : null,
                readOnly: isEmailVerified, // Make input read-only if verified
              }}
            />
            {emailError && (
              <div className="error-message" style={{ fontSize: "12px" }}>
                {emailError}
              </div>
            )}
          </div>

          {/* Username */}
          <div className="col-12e-sports-edit-userprofile-field ">
            <TextField
              label="username"
              variant="outlined"
              className="e-sports-edit-userprofile-input mt-2"
              InputProps={{
                readOnly: true, // This will make the field read-only
              }}
              value={userProfileGamerjiName}
            />
          </div>

          {/* avatar */}
          <div className="e-sports-edit-userprofile-avatar">
            <div className="e-sports-edit-userprofile-avatar-heading">
              avatar
            </div>
          </div>

          <div className="e-sports-edit-userprofile-avatar-list">
            <div className="e-sports-edit-userprofile-avatar-list-wrap">
              <div className="e-sports-edit-userprofile-avatar-list-bunddle">
                {avatarList?.length > 0 &&
                  avatarList?.map((e, index) => {
                    return e?._id === userProfileAvtar ? (
                      <div
                        className="e-sports-edit-userprofile-avatar-list-inner-wrap"
                        key={index}
                      >
                        <div className="e-sportsavatar-img selected-avatar-border">
                          <img
                            src={url?.IMAGE_URL + e?.img}
                            alt={e?.name}
                            style={{objectFit:"contain"}}
                          ></img>
                        </div>
                        <div className="e-sportsavatar-name">{e?.name}</div>
                      </div>
                    ) : !isPremiumUser && e?.isPremium && !e?.isBuy ? (
                      <div
                        className="e-sports-edit-userprofile-avatar-list-inner-wrap"
                        key={index}
                      >
                        <div
                          className={`e-sportsavatar-img e-sportsavatar-img-disabled ${
                            e?.isPremium && "e-sportsavatar-img-premium-user"
                          }`}
                        >
                          <img
                            className="e-sportsavatar-img"
                            src={url?.IMAGE_URL + e?.img}
                            alt={e?.name}
                            style={{objectFit:"contain"}}
                          ></img>
                          {/* {e?.isPremium && (
                            <span className="avatr-lock-premium">
                              <img
                                className="avatar-premium-size"
                                src={Premiumuser}
                                alt="Premium User Icon"
                              ></img>
                            </span>
                          )} */}
                          <span className="avatr-w-disabled">
                            <img
                              className="avatar-lock-size"
                              src={Lock}
                              alt="Lock Icon"
                            ></img>
                          </span>
                        </div>
                        <div className="e-sportsavatar-name">{e?.name}</div>
                      </div>
                    ) : !isPremiumUser && !e?.isPremium && !e?.isBuy ? (
                      <div
                        className="e-sports-edit-userprofile-avatar-list-inner-wrap"
                        key={index}
                      >
                        <div className="e-sportsavatar-img e-sportsavatar-img-disabled">
                          <img
                            className="e-sportsavatar-img"
                            src={url?.IMAGE_URL + e?.img}
                            alt={e?.name}
                            style={{objectFit:"contain"}}
                          ></img>
                          <span className="avatr-w-disabled">
                            <img
                              className="avatar-lock-size"
                              src={Lock}
                              alt="Lock Icon"
                            ></img>
                          </span>
                        </div>
                        <div className="e-sportsavatar-name">{e?.name}</div>
                      </div>
                    ) : (
                      <div
                        className="e-sports-edit-userprofile-avatar-list-inner-wrap"
                        key={index}
                        onClick={() => handleAvatarChange(e?._id)}
                      >
                        <div className="e-sportsavatar-img">
                          <img
                            src={url?.IMAGE_URL + e?.img}
                            alt={e?.name}
                            style={{objectFit:"contain"}}
                          ></img>
                        </div>
                        <div className="e-sportsavatar-name">{e?.name}</div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {avatarError && (
              <div className="error-message" style={{ fontSize: "12px" }}>
                {avatarError}
              </div>
            )}
          </div>

          <div className="avatar-premium-note mt-4">
            unlock more avatars with
            <span
              className="avatar-hyperlink-gj"
              onClick={() => navigate(routesFrontend.subscription)}
            >
              Vi Premium
            </span>
          </div>
          <button
            className="submit-button mt-4"
            onClick={() => {
              handleSubmit();
            }}
            disabled={isSaveBtnDisable}
          >
            save
          </button>
        </div>
      </div>
    </BaseHome>
  );
};

export default EditProfile;
